if (document.body.classList.contains('admin-bar')) {
	document.documentElement.style.setProperty('margin-top', '0', 'important');

	document.getElementById('wp-admin-bar-site-name').onclick = (e) => {
		e.stopPropagation();
		document.getElementById('wpadminbar').classList.toggle('is-expanded');
	}
}
